<template>
  <footer class="mt-auto border-t border-border bg-background text-foreground">
    <div class="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-12 sm:px-6 lg:px-10 lg:py-16">
      <div class="grid grid-cols-1 gap-10 md:grid-cols-3">
        <div class="space-y-4 text-center md:text-left">
          <div
            class="inline-flex items-center gap-3 rounded-full border border-primary/25 bg-primary/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground sm:tracking-[0.45em]"
          >
            Rattil
          </div>
          <p class="font-serif text-2xl leading-snug md:text-[2.25rem]">
            Elite Tradition.<br />
            Modern Expression.
          </p>
          <p class="text-sm text-muted-foreground">
            Quran-first experience focused on recitation, reflection, and consistency as part of everyday life.
          </p>
        </div>

        <div
          class="mx-auto flex flex-col items-center gap-3 text-sm uppercase tracking-[0.2em] text-muted-foreground sm:tracking-[0.35em] md:items-start"
        >
          <p>Legal</p>
          <div class="flex flex-wrap items-center justify-center gap-3 md:justify-start">
            <RouterLink
              v-for="item in nav"
              :key="item.to"
              :to="item.to"
              class="rounded-full border border-border px-4 py-2 text-xs font-semibold text-muted-foreground transition hover:border-primary hover:bg-primary/10 hover:text-foreground"
            >
              {{ item.label }}
            </RouterLink>
          </div>
        </div>

        <div class="space-y-3 rounded-3xl border border-primary/20 bg-accent/60 p-6 text-sm text-foreground/90">
          <p class="font-semibold uppercase tracking-[0.2em] text-muted-foreground sm:tracking-[0.35em]">
            Platform Focus
          </p>
          <p>
            Built for sustained Quran engagement with thoughtful UX, reliable technical execution, and meaningful
            Content + User API integration.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'

const nav = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
]
</script>
